import { v4 as uuidv4 } from "uuid";
import Cookies from "js-cookie";

// Before adding new code, keep in mind that this file is imported by many different modules.
// It's best to keep things separate by exporting small classes and functions separately,
// so that webpack can trim out unneeded codes and keep our load time short.
//
// Do NOT make a "God Object", one class/function/object having more than one responsibilities.

export class LocationMediator {
  // Don't change anything from `window.location` methods output, this class is used for mocking `window.location`
  // which is unmockable in browser Javascript. Therefore we need its behavior to be the exact same
  // with window.location's behaviors
  //
  // For example:
  //
  // Do NOT:
  //
  // static host() {
  //   return location.host.replace(/^(?:m\.|www\.)/,"")
  // }
  //
  // Do:
  //
  // static host() {
  //   return location.host
  // }
  //
  // Also do NOT add any methods that's not in `window.location`
  //
  static pathname() {
    return location.pathname;
  }
  static hostname() {
    return location.hostname;
  }
  static href() {
    return location.href;
  }
  static host() {
    // unlike hostname, host will include the port number ":3000"
    return location.host;
  }
  static protocol() {
    // window.location.protocol value will include the trailing colon, e.g: https: , http:
    return location.protocol;
  }
  static search() {
    return location.search;
  }
}

export class VidioApi {
  static baseUrl() {
    const strippedHost = LocationMediator.host().replace(/^(?:m\.|www\.)/, "");
    const hostname = VidioApi._generateApiHostname(strippedHost);
    return [LocationMediator.protocol(), hostname, "/"].join("");
  }

  static generateUrl(path = "/") {
    return VidioApi.baseUrl().slice(0, -1).concat(String(path));
  }

  static _isIap(strippedHost) {
    return strippedHost.indexOf('iap') > -1;
  }

  static _generateApiHostname(strippedHost) {
    if (VidioApi._isIap(strippedHost)) return strippedHost.replace(/^iap./, "//iap.api.")    
    return `//api.${strippedHost}`
  }
}

export class UniqueId {
  static get() {
    return uuidv4();
  }
}

export class ActiveLanguage {
  static get() {
    const defLang = "id";
    const langMeta = document.querySelector("meta[name=language]");
    if (langMeta === null) {
      return defLang;
    }
    const contentAttr = langMeta.getAttribute("content");
    return contentAttr === null || contentAttr === "" ? defLang : contentAttr;
  }
}

export class IsPremiumUser {
  static get() {
    return Cookies.get("_vidio") === "true";
  }
}

export class QueryString {
  static getParamValue(url, paramName) {
    let newParamName = paramName.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    let regex = new RegExp("[\\?&]" + newParamName + "=([^&#]*)");
    let results = regex.exec(url);
    return results === null
      ? ""
      : decodeURIComponent(results[1].replace(/\+/g, " "));
  }
}

export class DanaProfile {
  static get(callbackFn) {
    const method = "GET";
    const url = "/dashboard/dana_accounts/profile";
    const request = new XMLHttpRequest();
    request.open(method, url, true);
    request.onload = function () {
      if (this.status >= 200 && this.status < 400) {
        // Success!
        const data = JSON.parse(this.response);
        callbackFn(data);
      }
    };
    request.send();
  }
}

export class ComputedStyle {
  static _getFromWindow(el, property) {
    return window.getComputedStyle(el, null).getPropertyValue(property);
  }
  static get(el, property) {
    return el ? this._getFromWindow(el, property) : undefined;
  }
}

export function isLoggedIn() {
  const userMeta = document.querySelector('meta[name="current-username"]');
  if (userMeta == null) {
    return false;
  }
  const contentAttr = userMeta.getAttribute("content");
  return contentAttr !== null && contentAttr !== "";
}

export function isEmptyObject(obj) {
  return Object.keys(obj).length === 0 && obj.constructor === Object;
}

// platform
export function isEmbedVideo() {
  return LocationMediator.pathname().match(/\/embed(\/)?/) ? true : false;
}

export function isLivestreaming() {
  return LocationMediator.pathname().match(/\/live\//) ? true : false;
}

export function isMobile() {
  return LocationMediator.hostname().match(/^m\./) ? true : false;
}

export function isHomepage() {
  return LocationMediator.pathname() === '/';
}

export function getPlatform() {
  return isMobile() ? "web-mobile" : "web-desktop";
}

export class Orientation {
  static isPortrait() {
    return window.matchMedia("(orientation: portrait)").matches;
  }

  static isLandscape() {
    return window.matchMedia("(orientation: landscape)").matches;
  }
}

export function getHumanFileSize(bytes) {
  var thresh = 1024;

  if (Math.abs(bytes) < thresh) {
    return bytes + " B";
  }

  var units = ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
  var u = -1;

  do {
    bytes /= thresh;
    ++u;
  } while (Math.abs(bytes) >= thresh && u < units.length - 1);
  return bytes.toFixed(1) + " " + units[u];
}

export function previewUploadedImage(inputEl, previewEl, thumbnailEl) {
  inputEl.addEventListener("change", function () {
    if (inputEl.value !== "") {
      const reader = new FileReader();
      const image = new Image();
      const file = inputEl.files[0];

      reader.readAsDataURL(file);
      reader.onload = function (f) {
        image.src = f.target.result;
      };

      image.onload = function () {
        var imagePreview = previewEl;
        if (imagePreview === null) {
          imagePreview = thumbnailEl;
        }
        imagePreview.src = image.src;
        imagePreview.style.display = "block";
      };
      image.onerror = function () {
        window.alert("Invalid file type: " + file.type);
      };
    }
  });
}

export function getExperiment() {
  if (typeof window.variantOption === "undefined") {
    window.variantOption = ["1", "1", "0", "0"];
  }

  let choosenVariant = Math.floor(Math.random() * window.variantOption.length);
  return window.variantOption[choosenVariant];
}


const HTMLHelper = {
  renderCode: function (parent, htmlCode) {
    const leadingWhitespaceTrimmed = htmlCode.replace(/^\s+/gm, "");
    const trailingWhitespaceTrimmed = leadingWhitespaceTrimmed.replace(
      /\s+$/gm,
      ""
    );
    const lineBreakTrimmed = trailingWhitespaceTrimmed.replace(
      /(\r\n|\n|\r)/gm,
      ""
    );
    parent.innerHTML = lineBreakTrimmed;
  },

  appendCode: function (parent, htmlCode) {
    const leadingWhitespaceTrimmed = htmlCode.replace(/^\s+/gm, "");
    const trailingWhitespaceTrimmed = leadingWhitespaceTrimmed.replace(
      /\s+$/gm,
      ""
    );
    const lineBreakTrimmed = trailingWhitespaceTrimmed.replace(
      /(\r\n|\n|\r)/gm,
      ""
    );

    let temp = document.createElement("div");
    temp.innerHTML = lineBreakTrimmed;

    for (let i = 0; i < temp.children.length; i++) {
      parent.appendChild(temp.children[i].cloneNode(true));
    }
  },
};

export { HTMLHelper };
